<template>
  <div class="multimedia__content-list">
    <div class="multimedia__campaigns">
      <div>
        <span> {{ $t("multimedia.campaigns-assigned") }} </span>
        <span class="multimedia__campaigns-user">{{ user }} </span>
      </div>
      <div class="multimedia__campaigns-databank">
        {{ $t("multimedia.databank-from") }}
      </div>
    </div>
    <div
      v-for="(campaign, index) in campaigns"
      :key="index"
      @click="selectElement(campaign)"
      class="multimedia__content-item"
      :class="{
        'multimedia__content-item-selected': isSelectedCampaign(campaign),
      }"
      role="button"
    >
      <div
        class="multimedia__content-item-text"
        :class="{
          'multimedia__content-item-selected-text':
            isSelectedCampaign(campaign),
        }"
      >
        {{ campaign.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import DataBankMixin from '@/mixins/databank';

export default {
  mixins: [DataBankMixin],
  props: {
    selectedCampaign: {
      type: [String, null],
    },
    selectedCampaignName: {
      type: [String, null],
    },
  },
  computed: {
    ...mapGetters([
      'getUserCampaigns',
      'userInfo',
    ]),
    campaigns() {
      return this.getUserCampaigns;
    },
    conversation() {
      return !this.isHistory
        ? this.activeConversation.conversation
        : this.activeConversationHistory.conversation;
    },
    campaign() {
      return this.conversation.campaign;
    },
    user() {
      return this.userInfo.name;
    },

  },
  methods: {
    ...mapMutations(['setCurrentCampaign']),
    selectElement(campaign) {
      this.setCurrentCampaign(campaign?.id);
    },
    isSelectedCampaign(item) {
      return item.id === this.selectedCampaign;
    },
  },

};
</script>
